// ------- Click events --------

// Homepage Search Options:
export const GTM_CLICK_HOMEPAGE_SEARCH_OPTION_BUY = 'UiHomepHeadButBuyClk';
export const GTM_CLICK_HOMEPAGE_SEARCH_OPTION_RENT = 'UiHomepHeadButRentClk';
export const GTM_CLICK_HOMEPAGE_SEARCH_OPTION_SOLD = 'UiHomepHeadButSoldClk';
export const GTM_CLICK_HOMEPAGE_SEARCH_OPTION_AGENTS = 'UiHomepHeadButAgentClk';
export const GTM_CLICK_HOMEPAGE_SEARCH_BAR = 'UiHomepNavSearchBarClk';
export const GTM_CLICK_HOMEPAGE_SEARCH_BUTTON = 'UiHomepButSearchClk';

// Homepage Card Corner Buttons:
export const GTM_CLICK_HOME_PAGE_FOR_SALE_VIEW_MAP_BUTTON = 'UiHomepButMapClk';
export const GTM_CLICK_HOME_PAGE_LINKED_TEXT_BUTTON = 'UiHomepNavHomesForSaleClk';
export const GTM_CLICK_HOMEPAGE_SOLD_BUTTON = 'UiHomepButViewSoldClk';
export const GTM_CLICK_HOMEPAGE_MARKET_INSIGHTS_BUTTON = 'UiHomepButMarketInsightsClk';
export const GTM_CLICK_HOMEPAGE_FEATURED_BUTTON = 'UiHomepButFeaturedClk';

// Homepage Agent Search Card
export const GTM_CLICK_HOMEPAGE_AGENT_BUTTON = 'UiHomepButAgentSearchClk';

//Agent Profile page
export const GTM_AGENT_PROFILE_VIEW = 'UiAProfView';
export const GTM_AGENT_PROFILE_RETURN_TEXT_CLICK = 'UiAProfTxtReturnClk';
export const GTM_AGENT_PROFILE_SERVICE_BUTTON_CLICK ='UiAProfButServicesClk';
export const GTM_AGENT_JOIN_EXP_BUTTON_CLICK ='UiAProfButJoinClk';

// Homepage Card Swipe Buttons:
export const GTM_CLICK_HOMEPAGE_SWIPER_SALE = 'UiHomepIconNextSaleClk';
export const GTM_CLICK_HOMEPAGE_SWIPER_SOLD = 'UiHomepIconViewSoldClk';
export const GTM_CLICK_HOMEPAGE_SWIPER_FEATURED = 'UiHomepIconNextFeaturedClk';

// Homepage Content Blocks:
export const GTM_CLICK_HOMEPAGE_BUYERS_CARD_CLICK = 'UiHomepCardBuyersGuideClk';
export const GTM_CLICK_HOMEPAGE_BUYERS_BUTTON_CLICK = 'UiHomepButBuyersGuideClk';
export const GTM_CLICK_HOMEPAGE_SELLERS_CARD_CLICK = 'UiHomepCardSellersGuideClk';
export const GTM_CLICK_HOMEPAGE_SELLERS_BUTTON_CLICK = 'UiHomepButSellersGuideClk';

// Listing Cards:
export const GTM_CLICK_HOMEPAGE_SALE = 'UiHomepCardSaleClk';
export const GTM_CLICK_HOMEPAGE_SOLD = 'UiHomepCardSoldClk';
export const GTM_CLICK_HOMEPAGE_SOLD_SIGN_IN = 'UiHomepButSigninSoldClk';
export const GTM_CLICK_HOMEPAGE_FEATURED = 'UiHomepCardFeaturedCardClk';
export const GTM_CLICK_HOMEPAGE_MARKET_INSIGHTS = 'UiHomepCardMarketInsightsClk';
export const GTM_CLICK_HOMEPAGE_POPULAR_CITY_SELECT = 'UiHomepSelectPopularCity';
export const GTM_CLICK_LISTING_CARD = 'UiAddressCardListingClk';
export const GTM_CLICK_MAP_PIN_LISTING = 'UiSrcMapModListingClk';
export const GTM_CLICK_LISTING_SIMILAR = 'UiAddressCardSimilarClk';
export const GTM_CLICK_LISTING_MODAL_ADDRESS_TEXT = 'UiListingmTxtAddressClk';

// Buttons:
export const GTM_CLICK_AREA_PAGE_SAVE_SEARCH_BUTTON = 'UiAreaButAlertClk';
export const GTM_CLICK_AREA_CARD_SAVE_SEARCH_BUTTON = 'UiAreaCardSaveClk';
export const GTM_CLICK_AREA_CARD_EDIT_SEARCH_BUTTON = 'UiAreaButEditsaveClk';

// Search bar/button
export const GTM_CLICK_ALL_HEADER_SEARCH_BUTTON_CLICK = 'UiAllHeadButSearchClk';
export const GTM_CLICK_AREA_PAGE_NO_RESULTS = 'UiAllSrcBNoRslt';
export const GTM_CLICK_SEARCH_BAR_ABANDONED = 'UiAllSrcBSrcAbnd';
export const GTM_CLICK_SEARCH_BAR_SUBMITTED = 'UiAllSrcBSbt';
export const GTM_CLICK_SEARCH_BAR_TYPING = 'UiAllSrcBTyp';
export const GTM_CLICK_SEARCH_BAR_FOCUSED = 'UiAllSrcBClk';

// Add to Favourite:
export const GTM_CLICK_FAV_ON_MAP = 'UiSrcCardFavAdd';
export const GTM_CLICK_FAV_ON_AREA_PAGE = 'UiAreaCardFavAdd';
export const GTM_CLICK_FAV_ON_MODAL = 'UiListingmIconFavAdd';
export const GTM_CLICK_FAV_ON_LISTING_MODAL = 'UiListingmButFavAlertClk';
export const GTM_CLICK_FAV_ON_ADDRESS_PAGE = 'UiAddressButFavAlertClk';
export const GTM_CLICK_VIEW_ON_LISTING_MODAL = 'UiListingmButFavViewClk';
export const GTM_CLICK_VIEW_ON_ADDRESS_PAGE = 'UiAddressButFavViewClk';

// User Profile Page
export const GTM_VISIT_PAGE_USER_PROFILE = 'UiProfView';
export const GTM_CLICK_PROFILE_EDIT_NAME = 'UiProflButEditNameClk';
export const GTM_CLICK_PROFILE_EDIT_EMAIL = 'UiProfButChangeEmailClk';
export const GTM_CLICK_PROFILE_CHANGE_PASSWORD = 'UiProfButChangePWClk';
export const GTM_CLICK_PROFILE_CREATE_PASSWORD = 'UiProfButCreatePWClk';
export const GTM_CLICK_PROFILE_EDIT_PHONE_NUMBER = 'UiProfButEditPhoneClk';

// EXP Theme Nagivation buttons
export const GTM_CLICK_NAV_PAGE_CHANGE = 'UiASrcNavChgPgClk';
export const GTM_CLICK_NAV_LOCALE_CHANGE_EN_CA = 'UiAllHeadButLocalizationENClk';
export const GTM_CLICK_NAV_LOCALE_CHANGE_FR_CA = 'UiAllHeadButLocalizationFRClk';

// Agent Search Page
export const GTM_CLICK_AGENT_PAGE_LOCATION_SEARCH_BAR = 'UiASrcNavLocBarClk';
export const GTM_CLICK_AGENT_PAGE_NAME_SEARCH_BAR = 'UiASrcNavNameBarClk';
export const GTM_CLICK_AGENT_PAGE_SUGGESTED_LOCATIONS = 'UiASrcNavSgLocClk';
export const GTM_CLICK_AGENT_PAGE_SUGGESTED_NAMES = 'UiASrcNavSgNameClk';
export const GTM_CLICK_AGENT_PAGE_EDIT_COUNTRY = 'UiASrcNavCtryClk';
export const GTM_CLICK_FEATURED_AGENT_CARD = 'UiASrcCardFeatAgentClk';
export const GTM_CLICK_REGULAR_AGENT_CARD = 'UiASrcCardAgentClk';
export const GTM_VISIT_AGENT_SEARCH_PAGE = 'UiASrcView';

// Agent Profile
export const GTM_CLICK_AGENT_PROFILE_COPY_EMAIL = 'UiAProfIconCopyEmailClk';
export const GTM_CLICK_AGENT_PROFILE_COPY_PHONE = 'UiAProfIconCopyPhoneClk';
export const GTM_CLICK_AGENT_PROFILE_FACEBOOK = 'UiAProfButFacebookClk';
export const GTM_CLICK_AGENT_PROFILE_WEBSITE = 'UiAProfButWebsiteClk';
export const GTM_CLICK_AGENT_PROFILE_LINKEDIN = 'UiAProfButLinkedInClk';
export const GTM_CLICK_AGENT_PROFILE_TWITTER = 'UiAProfButTwitterClk';
export const GTM_CLICK_AGENT_PROFILE_INSTAGRAM = 'UiAProfButInstagramClk';
export const GTM_CLICK_AGENT_PROFILE_YOUTUBE = 'UiAProfButYoutubeClk';
export const GTM_CLICK_AGENT_PROFILE_TIKTOK = 'UiAProfButTikTokClk';

// My Zoocasa:
export const GTM_CLICK_NAV_VIEW_ALL_SAVED_SEARCHES = 'UiAllNavSavedSrchClk';
export const GTM_CLICK_NAV_MY_ZOOCASA = 'UiAllNavMyZooClk';
export const GTM_CLICK_MOBILE_BOT_NAV_ON_MAP_MY_FAV = 'UiAllToolbarFav';
// -----------------------------

// Area Page
export const GTM_CLICK_AREA_PAGE_MORE_FILTERS_BUTTON = 'UiAreaQfMoreButClk';
export const GTM_CLICK_AREA_PAGE_MAP_BUTTON = 'UiAreaQfMapButClk';

// Hybrid Page
export const GTM_CLICK_HYBRID_PAGE_MOBILE_MAP_TOGGLE = 'UiHybridMobMapToggleClk';
export const GTM_CLICK_HYBRID_PAGE_MOBILE_MAP_TOGGLE_AFTER_JIGGLE = 'UiHybridMobMapToggleAfterJiggleClk';
export const GTM_CLICK_HYBRID_PAGE_MOBILE_MAP_TOGGLE_BEFORE_JIGGLE = 'UiHybridMobMapToggleBeforeJiggleClk';
// Hybrid page chat panel (Intel Search)
export const GTM_CLICK_HYBRID_PAGE_INTEL_OPEN = 'UiHybridIntelButOpenClk';
export const GTM_CLICK_HYBRID_PAGE_CHAT_CHIP = 'UiHybridChatButChipClk';
export const GTM_CLICK_HYBRID_PAGE_CHAT_FILTERS_TOGGLE = 'UiHybridChatTglFiltersClk';
/** Desktop map/list layout buttons on hybrid/area map layout */
export const GTM_CLICK_HYBRID_PAGE_DESKTOP_EXPAND_MAP = 'UiHybridDeskButExpandMapClk';
export const GTM_CLICK_HYBRID_PAGE_DESKTOP_SHOW_LIST = 'UiHybridDeskButShowListClk';
export const GTM_CLICK_HYBRID_PAGE_DESKTOP_HIDE_MAP = 'UiHybridDeskButHideMapClk';
export const GTM_CLICK_HYBRID_PAGE_DESKTOP_RESTORE_MAP = 'UiHybridDeskButRestoreMapClk';
/** Remove Boundary — navigates to map view without polygon (mobile + desktop hybrid / area-page-v2) */
export const GTM_CLICK_HYBRID_PAGE_REMOVE_BOUNDARY = 'UiHybridRmBoundaryClk';
/** Area-page-v2 left rail — Collections / Insights destinations */
export const GTM_CLICK_HYBRID_PAGE_RAIL_COLLECTIONS = 'UiHybridRailCollectionsClk';
export const GTM_CLICK_HYBRID_PAGE_RAIL_INSIGHTS = 'UiHybridRailInsightsClk';
/** Area-page-v2 saved-search panel — apply an existing saved search */
export const GTM_CLICK_HYBRID_PAGE_SAVED_SEARCH_APPLY = 'UiHybridCardSavedSrchClk';

// Address Page:
export const GTM_CLICK_ADDRESS_PAGE_IMAGE = 'UiAddressImgClk';
export const GTM_CLICK_ADDRESS_PAGE_IMAGE_RIGHT_ARROW = 'UiAddressButRarrowClk';
export const GTM_CLICK_ADDRESS_PAGE_PRICE_HISTORY_BUTTON = 'UiAddressButPriceHisClk';
export const GTM_CLICK_ADDRESS_PAGE_VIRTUAL_TOUR_BUTTON = 'UiAddressButVTourClk';
export const GTM_CLICK_ADDRESS_PAGE_DESCRIPTION_TAB = 'UiAddressTabDescripClk';
export const GTM_CLICK_ADDRESS_PAGE_ROOMS_TAB = 'UiAddressTabRoomsClk';
export const GTM_CLICK_ADDRESS_PAGE_COMPARABLE_PROPERTY_RIGHT = 'UiAddressRCCardSoldClk';
export const GTM_CLICK_ADDRESS_PAGE_PRICE_HISTORY_LISTING = 'UiAddressTabPriceListClk';
export const GTM_CLICK_ADDRESS_PAGE_SALES_ACTIVITY_TAB = 'UiAddressTabSalesClk';
export const GTM_CLICK_ADDRESS_PAGE_SCHOOL_NAME = 'UiAddressTabSchoolClk';
export const GTM_CLICK_ADDRESS_PAGE_MORTGAGE_TAB = 'UiAddressTabMortClk';
export const GTM_CLICK_ADDRESS_PAGE_DEMOGRAPHICS_TAB = 'UiAddressTabDemosClk';
export const GTM_CLICK_ADDRESS_PAGE_COMMUTE_TAB = 'UiAddressTabCommuteClk';
export const GTM_CLICK_ADDRESS_PAGE_COMPARABLE_LISTING_BOTTOM = 'UiAddressCardSoldClk';
export const GTM_CLICK_ADDRESS_PAGE_MAP_TAB = 'UiAddressTabMapClk';
export const GTM_CLICK_ADDRESS_PAGE_MAP_SATELLITE_VIEW = 'UiAddressButSatelliteClk';
export const GTM_CLICK_ADDRESS_PAGE_MAP_STREET_VIEW = 'UiAddressButStreetClk';
export const GTM_CLICK_ADDRESS_PAGE_SHARE_ICON = 'UiAddressIconShareClk';
export const GTM_CLICK_ADDRESS_PAGE_FAVOURITE_ICON = 'UiAddressIconFavAdd';
export const GTM_CLICK_ADDRESS_PAGE_MAIN_PVR_CTA = 'UiAddressButContactClk';
export const GTM_CLICK_ADDRESS_PAGE_PHOTO_GALLERY_PVR_CTA = 'UiAddressGalButContactClk';
export const GTM_CLICK_ADDRESS_PAGE_ONLINE_ESTIMATE_BUT_VIEW = 'XpA_AddressOnlineEstButView';
export const GTM_CLICK_ADDRESS_PAGE_OFFLINE_ESTIMATE_BUT_VIEW = 'XpB_AddressOfflineEstButView';
export const GTM_CLICK_ADDRESS_PAGE_ONLINE_ESTIMATE_BUT_CLICK = 'XpA_AddressOnlineEstButClk';
export const GTM_CLICK_ADDRESS_PAGE_OFFLINE_ESTIMATE_BUT_CLICK = 'XpB_AddressOfflineEstButClk';

// Address Page V2 Events
export const GTM_CLICK_ADDRESS_HERO_IMAGE_SWIPE = 'UiAddressHeroButSwipeClk';
export const GTM_CLICK_ADDRESS_GALLERY_SEE_ALL = 'UiAddressGalButSeeAllClk';

// Connection Request Form Experiment (dj-listing-connection-request-form-redesign)
// XpA_ = variation 0 (control), XpB_ = variation 1 (new CTA card)
export const GTM_XP_CONNECTION_REQUEST_FORM_CONTROL_CTA_CLICK = 'XpA_AddressConnReqCtaClk';
export const GTM_XP_CONNECTION_REQUEST_FORM_VARIATION_CTA_CLICK = 'XpB_AddressConnReqCtaClk';


// Listing Modal
export const GTM_CLICK_ADDRESS_MODAL_MAP_SATELLITE_VIEW = 'UiAddressMdlButSatelliteClk';
export const GTM_CLICK_ADDRESS_MODAL_MAP_STREET_VIEW = 'UiAddressMdlButStreetClk';
export const GTM_ADDRESS_MODAL_FUB_PAGE_VIEW = 'fub_listing_popup';
export const GTM_ADDRESS_MODAL_VIEW = 'UiListingmView';
export const GTM_MOBILE_LISTING_PAGE_VIEW = 'Mobile_Listing_Page_View';
export const GTM_ADDRESS_SOLD_AUTH_VIEW = 'UiAddressSoldAuthView';
export const GTM_ADDRESS_SOLD_NON_AUTH_VIEW = 'UiAddressSoldNonAuthView';

// Search Page
export const GTM_CLICK_SEARCH_PAGE_SATELLITE_VIEW = 'UiSrcMapButSatelliteClk';
export const GTM_CLICK_SEARCH_PAGE_STREET_VIEW = 'UiSrcMapButStreetClk';
export const GTM_SEARCH_PAGE_VIEW = 'UiSearchpView';
export const GTM_SEARCH_PAGE_MLML_VIEW = 'UiSrcMLMLView';
/** Classic search more-filters control (`TrackMoreButtonClick`). */
export const GTM_CLICK_SEARCH_PAGE_MORE_FILTERS_BUTTON = 'UiSrchQfMoreButClk';
/** Classic search save-search CTA (`TrackSaveSearchButtonClick`). */
export const GTM_CLICK_SEARCH_PAGE_SAVE_SEARCH_BUTTON = 'UiSrchQfSaveButClk';
/**
 * `trackEvent` category for search-page-v2.
 */
export const GTM_CATEGORY_SEARCH_PAGE_V2 = 'search-page-v2';
export const GTM_CLICK_MAP_PAGE_SIDEBAR_CARD = 'UiMapPgCardClk';
export const GTM_CLICK_MAP_PAGE_PIN = 'UiMapPgBubbleClk';
export const GTM_CLICK_MAP_PAGE_LISTING_POPOVER = 'UiMapPgPopupPropertyClk';
export const GTM_MAP_PAGE_FAVOURITE_PROPERTY = 'UiMapPgBubbleFavAdd';

// Simple Chatbot Experiment
export const GTM_CLICK_SEARCH_PAGE_SIMPLE_CHATBOT_EXPERIMENT_A = 'XpA_SrcSimpChatModView';
export const GTM_CLICK_SEARCH_PAGE_SIMPLE_CHATBOT_EXPERIMENT_B = 'XpB_SrcSimpChatModView';

// Smart Chatbot Experiment
// TODO CONFIRMN THESE EVENTS
export const GTM_CLICK_SEARCH_PAGE_SMART_CHATBOT_EXPERIMENT_A = 'XpA_SrcSmartChatModView';
export const GTM_CLICK_SEARCH_PAGE_SMART_CHATBOT_EXPERIMENT_B = 'XpB_SrcSmartChatModView';

// Quebec Popup
export const GTM_CLICK_QUEBEC_POPUP_HOME_STAY = 'UiHomepMdlButQBStayClk';
export const GTM_CLICK_QUEBEC_POPUP_HOME_LEAVE = 'UiHomepMdlButQBLeaveClk';
export const GTM_CLICK_QUEBEC_POPUP_HOME_CLOSE = 'UiHomepMdlButQBCloseClk';

export const GTM_CLICK_QUEBEC_POPUP_AREA_STAY = 'UiAreaMdlButQBStayClk';
export const GTM_CLICK_QUEBEC_POPUP_AREA_LEAVE = 'UiAreaMdlButQBLeaveClk';
export const GTM_CLICK_QUEBEC_POPUP_AREA_CLOSE = 'UiAreaMdlButQBCloseClk';

export const GTM_CLICK_QUEBEC_POPUP_MAP_STAY = 'UiSrcMdlButQBStayClk';
export const GTM_CLICK_QUEBEC_POPUP_MAP_LEAVE = 'UiSrcMdlButQBLeaveClk';
export const GTM_CLICK_QUEBEC_POPUP_MAP_CLOSE = 'UiSrcMdlButQBCloseClk';

// Home Appraisal
export const GTM_CLICK_APPRAISAL_HOME_SEARCH_BAR = 'UiEstPNavSearchBarClk';
export const GTM_CLICK_APPRAISAL_HOME_SEARCH_RESULT = 'UiEstPButSearchClk';
export const GTM_CLICK_APPRAISAL_BACK_TO_SEARCH = 'UiEstPButBackClk';
export const GTM_CLICK_APPRAISAL_ESTIMATE = 'UiEstPButGetEstClk';
export const GTM_CLICK_APPRAISAL_EDIT_PROPERTY_DETAILS = 'UiEstRTxtEditClk';
export const GTM_CLICK_APPRAISAL_TALK_TO_AGENT = 'UiEstRTxtAgentClk';
export const GTM_CLICK_APPRAISAL_ENTER_EMAIL = 'UiEstRTxtEmailClk';
export const GTM_CLICK_APPRAISAL_DETAIL_ESTIMATE_FOR_FREE = 'UiEstRButEstClk';
export const GTM_CLICK_APPRAISAL_SIMILAR_AVAILABLE_CARD = 'UiEstRCardSaleClk';
export const GTM_CLICK_APPRAISAL_SIMILAR_SOLD_CARD = 'UiEstRCardSoldClk';
export const GTM_CLICK_APPRAISAL_DETAIL_ESTIMATE_FOR_FREE_POPUP = 'UiEstRMdlButEstClk';
export const GTM_CLICK_APPRAISAL_SPEAK_TO_AGENT = 'UiEstErrButEstClk';
export const GTM_CLICK_APPRAISAL_NO_ESTIMATE_BACK_TO_SEARCH = 'UiEstErrButBackClk';
export const GTM_CLICK_APPRAISAL_NO_ESTIMATE_SIMILAR_SOLD_CARD = 'UiEstErrCardSoldClk';
export const GTM_CLICK_APPRAISAL_NO_ESTIMATE_SIMILAR_AVAILABLE_CARD = 'UiEstErrCardSaleClk';
export const GTM_CLICK_APPRAISAL_NO_ESTIMATE_DETAIL_ESTIMATE_FOR_FREE_POPUP = 'UiEstErrMdlButEstClk';
export const GTM_CLICK_APPRAISAL_GOOGLE_ADDRESS = 'UiEstPTxtGoogleAddressClk';
export const GTM_CLICK_APPRAISAL_LISTING_ADDRESS = 'UiEstPTxtListingAddressClk';

export const GTM_CLICK_FILTER_BUY_MAP = 'UiSrcFltButBuyClk';
export const GTM_CLICK_FILTER_RENT_MAP = 'UiSrcFltButRentClk';
export const GTM_CLICK_FILTER_SOLD_MAP = 'UiSrcFltButSoldClk';
export const GTM_CLICK_FILTER_HOUSE_MAP = 'UiSrcFltButHouseClk';
export const GTM_CLICK_FILTER_TOWNHOUSE_MAP = 'UiSrcFltButTownhouseClk';
export const GTM_CLICK_FILTER_CONDO_MAP = 'UiSrcFltButCondoClk';
export const GTM_CLICK_FILTER_LAND_MAP = 'UiSrcFltButLandClk';
export const GTM_CLICK_FILTER_FARM_MAP = 'UiSrcFltButFarmClk';
export const GTM_CLICK_FILTER_COMMERCIAL_MAP = 'UiSrcFltButCommercialClk';
export const GTM_CLICK_FILTER_PRICE_APPLY_MAP = 'UiSrcFltButPriceApplyClk';
export const GTM_CLICK_FILTER_BEDS_MAP = 'UiSrcFltButBedsClk';
export const GTM_CLICK_FILTER_EXACT_NUMBER_BEDS_MAP = 'UiSrcFltButExactNumClk';

// Filters
export const GTM_CLICK_FILTER_BUY = 'UiFltMdlButBuyClk';
export const GTM_CLICK_FILTER_RENT = 'UiFltMdlButRentClk';
export const GTM_CLICK_FILTER_SOLD = 'UiFltMdlButSoldClk';
export const GTM_CLICK_FILTER_PRICE = 'UiFltMdlButPriceClk';
export const GTM_CLICK_FILTER_LISTED_DATE = 'UiFltMdlButDateClk';
export const GTM_CLICK_FILTER_SQUARE_FEET = 'UiFltMdlButSqFtClk';
export const GTM_CLICK_FILTER_BEDS = 'UiFltMdlButBedsClk';
export const GTM_CLICK_FILTER_BEDS_EXACT = 'UiFltMdlButBedsExactClk';
export const GTM_CLICK_FILTER_BATHROOMS = 'UiFltMdlButBathsClk';
export const GTM_CLICK_FILTER_PARKING = 'UiFltMdlButParkingClk';
export const GTM_CLICK_FILTER_LOCKER = 'UiFltMdlButLockerClk';
export const GTM_CLICK_FILTER_NO_LOCKER = 'UiFltMdlButNoLockerClk';
export const GTM_CLICK_FILTER_MAX_MAINTENANCE_FEES = 'UiFltMdlButFeeClk';
export const GTM_CLICK_FILTER_LISTING_STATUS_ACTIVE = 'UiFltMdlButActiveClk';
export const GTM_CLICK_FILTER_LISTING_STATUS_EXPIRED = 'UiFltMdlButExpiredClk';
export const GTM_CLICK_FILTER_RESET = 'UiFltMdlButResetClk';
export const GTM_CLICK_FILTER_SAVE_SEARCH = 'UiFltMdlButSaveSearchClk';
export const GTM_CLICK_FILTER_APPLY = 'UiFltMdlButApplyClk';
export const GTM_CLICK_FILTER_HOUSE = 'UiFltMdlButHouseClk';
export const GTM_CLICK_FILTER_TOWNHOUSE = 'UiFltMdlButTownhouseClk';
export const GTM_CLICK_FILTER_CONDO = 'UiFltMdlButCondoClk';
export const GTM_CLICK_FILTER_LAND = 'UiFltMdlButLandClk';
export const GTM_CLICK_FILTER_FARM = 'UiFltMdlButFarmClk';
export const GTM_CLICK_FILTER_COMMERCIAL = 'UiFltMdlButCommercialClk';

export const GTM_CLICK_FILTER_BUY_AREA = 'UiAreaFltButBuyClk';
export const GTM_CLICK_FILTER_RENT_AREA = 'UiAreaFltButRentClk';
export const GTM_CLICK_FILTER_SOLD_AREA = 'UiAreaFltButSoldClk';
export const GTM_CLICK_FILTER_ACTIVE_AREA = 'UiAreaFltButActiveClk';
export const GTM_CLICK_FILTER_EXPIRED_AREA = 'UiAreaFltButExpiredClk';
export const GTM_CLICK_FILTER_HOUSE_AREA = 'UiAreaFltButHouseClk';
export const GTM_CLICK_FILTER_TOWNHOUSE_AREA = 'UiAreaFltButTownhouseClk';
export const GTM_CLICK_FILTER_CONDO_AREA = 'UiAreaFltButCondoClk';
export const GTM_CLICK_FILTER_LAND_AREA = 'UiAreaFltButLandClk';
export const GTM_CLICK_FILTER_FARM_AREA = 'UiAreaFltButFarmClk';
export const GTM_CLICK_FILTER_COMMERCIAL_AREA = 'UiAreaFltButCommercialClk';
export const GTM_CLICK_FILTER_PRICE_APPLY_AREA = 'UiAreaFltButPriceApplyClk';
export const GTM_CLICK_FILTER_EXACT_NUMBER_AREA = 'UiAreaFltButExactNumClk';
export const GTM_CLICK_FILTER_BEDS_AREA = 'UiAreaFltButBedsClk';

// eXp Join page
export const GTM_CLICK_IM_READY_BUTTON_JOIN_EXP = 'UiJnHomePButImReadyClk';
export const GTM_CLICK_CONTACT_US_BUTTON_JOIN_EXP = 'UiJnHomePButContactUsClk';
export const GTM_CLICK_LEARN_MORE_BUTTON_JOIN_EXP = 'UiJnHomePButLearnMoreClk';
export const GTM_CLICK_JOIN_NOW_FAB_JOIN_EXP = 'UiJnHomePButJoinNowFabClk';
export const GTM_CLICK_BOOST_CANDIDATE_BUTTON_JOIN_EXP = 'UiJnHomePButBoostCandidateClk';
export const GTM_CLICK_THRIVE_CANDIDATE_BUTTON_JOIN_EXP = 'UiJnHomePButThriveCandidateClk';
export const GTM_CLICK_BUILT_FOR_THIS_JOIN_US_BUTTON_JOIN_EXP = 'UiJnHomePButBuiltforThisJoinClk';
export const GTM_CLICK_SIGN_ME_UP_BUTTON_JOIN_EXP = 'UiJnHomePButSignMeUpClk';
export const GTM_CLICK_GET_NOW_BUTTON_JOIN_EXP = 'UiJnHomePButGetNowClk';

// ------- View events --------
// Address Page:
export const GTM_VIEW_ADDRESS_PAGE_KEY_FACTS_TAB = 'UiAddressTabKeyFactsView';
export const GTM_VIEW_ADDRESS_PAGE_PRICE_HISTORY_TAB = 'UiAddressTabPriceHisView';
export const GTM_VIEW_ADDRESS_PAGE_AVERAGE_SOLD_PRICE_TAB = 'UiAddressTabSoldDataView';
export const GTM_VIEW_ADDRESS_PAGE_SCHOOLS_TAB = 'UiAddressTabSchoolsView';
export const GTM_VIEW_ADDRESS_PAGE_ZOOPRAISAL = 'UiAddressTxtZoopraView';
export const GTM_VIEW_ADDRESS_PAGE_SOLD_LISTING = 'UiAddressSoldView';
export const GTM_VIEW_ADDRESS_PAGE_FOR_SALE_LISTING = 'UiAddressSaleView';
export const GTM_VIEW_ADDRESS_PAGE_INACTIVE_LISTING = 'UiAddressInactiveView';
export const GTM_VIEW_ADDRESS_PAGE_STANDARD_LISTING = 'UiAddressEmptyView';
export const GTM_VIEW_ADDRESS_PAGE_SOLD_LISTING_MODAL = 'UiAddressMdlSoldView';
export const GTM_VIEW_ADDRESS_PAGE_FOR_SALE_LISTING_MODAL = 'UiAddressMdlForSaleView';
export const GTM_VIEW_ADDRESS_PAGE_INACTIVE_LISTING_MODAL = 'UiAddressMdlInactiveView';
export const GTM_VIEW_ADDRESS_PAGE_MLML = 'UiAddressMLMLView';
export const GTM_VIEW_ADDRESS_PAGE = 'UiAddresspView';

// Home Appraisal
export const GTM_VIEW_APPRAISAL_HOME = 'UiEstPView';
export const GTM_VIEW_APPRAISAL_ESTIMATE = 'UiEstRView';
export const GTM_VIEW_APPRAISAL_NO_ESTIMATE = 'UiEstErrView';
export const GTM_CLICK_VALUATION_TIPS_LINK = 'UiEstRTxtTipClk';
export const GTM_CLICK_VALUATION_TIPS_ESTIMATE_BUTTON = 'UiEstRButTipsClk';
export const GTM_VIEW_APPRAISAL_ESTIMATE_EXPANDED = 'UiEstRRangeView';
export const GTM_VIEW_APPRAISAL_ESTIMATE_FOR_SALE_RANGE = 'UiEstRForSaleRangeView';

// Content Page
export const GTM_VIEW_EXP_JOIN_PAGE = 'UiExpJoinPView';

// Area Page
export const GTM_VIEW_AREA_PAGE = 'UiAreapView';
/**
 * `trackEvent` category / GA4 `event_category` for area-page-v2. (So that we can distinguish between classic and new area page events)
 */
export const GTM_CATEGORY_AREA_PAGE_V2 = 'area-page-v2';

// Home Page
export const GTM_VIEW_HOME_PAGE = 'UiHomePView';

// Globe Hero Section
export const GTM_GLOBE_ROTATE = 'UiHomePGlobeRotate';
export const GTM_GLOBE_ZOOM = 'UiHomePGlobeZoom';
export const GTM_GLOBE_DOUBLE_CLICK_ZOOM = 'UiHomePGlobeDblClkZoom';
export const GTM_GLOBE_PROVINCE_MARKER_CLICK = 'UiHomePGlobeProvinceClk';
export const GTM_GLOBE_CLUSTER_CLICK = 'UiHomePGlobeClusterClk';

// ------- Auth events -------
// Sign up:
export const GTM_AUTH_SIGN_UP_GENERAL = 'sign_up';
export const GTM_AUTH_SIGN_UP_NORMAL_EMAIL = 'UiAllAuthCodeEmailSignup';
export const GTM_AUTH_SIGN_UP_GOOGLE = 'UiAllAuthCodeGoogSignup';
export const GTM_AUTH_SIGN_UP_FACEBOOK = 'UiAllAuthCodeFbookSignup';
export const GTM_AUTH_SIGN_UP_APPLE = 'UiAllAuthCodeAppleSignup';
/** Apple sign-up where the user shared their real email address. */
export const GTM_AUTH_SIGN_UP_APPLE_OPEN_EMAIL = 'UiAllAuthCodeAppleOpenEmailSignup';
/** Apple sign-up where the user chose "Hide My Email" (private relay address). */
export const GTM_AUTH_SIGN_UP_APPLE_PRIVATE_EMAIL = 'UiAllAuthCodeApplePrivateEmailSignup';
/** User tapped "Sign in with Apple" — fired before the IDP redirect. */
export const GTM_AUTH_APPLE_SIGN_IN_INIT = 'UiAllAuthAppleSignInInit';
/** IDP redirect succeeded and phone collection is required — new social user identified. */
export const GTM_AUTH_SOCIAL_PHONE_COLLECTION_START = 'UiAllAuthSocialPhoneCollectionStart';
/** Phone submitted successfully — social registration fully complete. */
export const GTM_AUTH_SOCIAL_PHONE_COLLECTION_COMPLETE = 'UiAllAuthSocialPhoneCollectionComplete';
/** User dismissed the phone collection modal without submitting a phone number. */
export const GTM_AUTH_SOCIAL_PHONE_COLLECTION_DISMISSED = 'UiAllAuthSocialPhoneCollectionDismissed';
// Sign in (returning email/password users):
export const GTM_AUTH_SIGN_IN_EMAIL = 'UiAllAuthCodeEmailSignIn';
// Sign in (returning social users):
export const GTM_AUTH_SOCIAL_SIGN_IN_GENERAL = 'UiAllAuthSocialSignIn';
export const GTM_AUTH_SIGN_IN_GOOGLE = 'UiAllAuthCodeGoogSignIn';
export const GTM_AUTH_SIGN_IN_FACEBOOK = 'UiAllAuthCodeFbookSignIn';
export const GTM_AUTH_SIGN_IN_APPLE = 'UiAllAuthCodeAppleSignIn';
/** Apple sign-in where the user shared their real email address. */
export const GTM_AUTH_SIGN_IN_APPLE_OPEN_EMAIL = 'UiAllAuthCodeAppleOpenEmailSignIn';
/** Apple sign-in where the user chose "Hide My Email" (private relay address). */
export const GTM_AUTH_SIGN_IN_APPLE_PRIVATE_EMAIL = 'UiAllAuthCodeApplePrivateEmailSignIn';
// Login modal role selection (eXp-US state 0) — one per role button.
export const GTM_AUTH_ROLE_AGENT = 'UiAllAuthRoleAgentClk';
export const GTM_AUTH_ROLE_BUYER_SELLER = 'UiAllAuthRoleBuyerSellerClk';
export const GTM_AUTH_ROLE_OTHER = 'UiAllAuthRoleOtherClk';
export const GTM_HOMEPAGE_SIGN_UP_FROM_URL_VIEW = 'UiHomePModSignUpDirectView';
export const GTM_HOMEPAGE_SIGN_UP_FROM_URL_CLOSE = 'UiHomePModSignUpDirectClose';
export const GTM_HOMEPAGE_SIGN_UP_FROM_URL_CONTINUE = 'UiHomePModSignUpDirectCont';

// -------- Error events ---------
// Listing Modal
export const GTM_CLICK_LISTING_MODAL_LOAD_ERROR = 'UiListingMLoadErr';
export const GTM_CLICK_LISTING_MODAL_TIMEOUT_ERROR = 'UiListingMTimeoutErr';
// Listing Page
export const GTM_LISTING_PAGE_LOAD_UI_ERROR = 'UiAddressLoadErr';
export const GTM_LISTING_PAGE_TIMEOUT_UI_ERROR = 'UiAddressTimeoutErr';

export const GTM_EXP_HOME_PAGE_HEADER_IMAGE_CLICK = 'UiHomePHeadImgClk';
export const GTM_EXP_FIND_YOUR_HOME_CLICK_HOME_PAGE = 'UiHomePHeadButFYHClk';
export const GTM_EXP_FIND_YOUR_HOME_CLICK_UNIVERSAL = 'UiAllHeadButFYHClk';
export const GTM_EXP_VIEW_MAP_CLICK = 'UiHomePButMapClk';
export const GTM_EXP_LOCATION_TEXT_CLICK = 'UiHomePTxtSLocClk';
export const GTM_EXP_CAROUSEL_CARD_CLICK = 'UiHomePCardCarClk';
export const GTM_EXP_JOIN_EXP_BUTTON_CLICK = 'UiHomePButJEXPClk';
export const GTM_EXP_LEARN_MORE_BUTTON_CLICK = 'UiHomePButLMClk';

export const CARD_NUMBER_PLACEHOLDER = '<CardNumber>';
export const GTM_EXP_FLIP_CARD_CLICK = `UiHomePCardFlip${CARD_NUMBER_PLACEHOLDER}Clk`;
export const GTM_EXP_OPEN_CARD_CLICK = `UiHomePCardOpen${CARD_NUMBER_PLACEHOLDER}Clk`;

// -------- Experiments ---------
// Area page
export const GTM_AREA_PAGE_MAP_CARD_FOURTH_VERSION_A = 'XpA_AreaMapCardView2';
export const GTM_AREA_PAGE_MAP_CARD_FOURTH_VERSION_B = 'XpB_AreaMapCardView2';
export const GTM_AREA_PAGE_MAP_CARD_FOURTH_CLICK= 'XpB_AreaMapCardClk2';

// "Sold" Navigation Links
export const GTM_EXPERIMENT_SOLD_NAV_LINK_VIEW = 'Xp_AllSoldPricesNavView';
export const GTM_EXPERIMENT_SOLD_NAV_LINK_CLICK = 'Xp_AllSoldPricesNavClk';
export const GTM_EXPERIMENT_A_ALL_SOLD_PRICES_NAV_VIEW = 'XpA_AllSoldPricesNavView';
export const GTM_EXPERIMENT_A_ALL_SOLD_PRICES_NAV_CLICK = 'XpA_AllSoldPricesNavClk';
export const GTM_EXPERIMENT_B_ALL_SOLD_PRICES_NAV_VIEW = 'XpB_AllSoldPricesNavView';
export const GTM_EXPERIMENT_B_ALL_SOLD_PRICES_NAV_CLICK = 'XpB_AllSoldPricesNavClk';

// List of emails that is prohibited to send event to GTM
export const GTM_PROHIBITED_EMAILS = ['ui-automation+dev@zoocasa.com', 'ui-automation-prod@testaccounts.zoocasa.com'];

// Map Single Listing Preview Experiment GTM Events (map-single-cluster-experiment)
export const GTM_MAP_SINGLE_LISTING_PREVIEW_VERSION_A = 'XpA_MapSrcNormalMapPrevNavView';
export const GTM_MAP_SINGLE_LISTING_PREVIEW_VERSION_B = 'XpB_MapSrcListingMapPrevNavView';
export const GTM_MAP_SINGLE_LISTING_PREVIEW_CLICK_A = 'XpA_MapSrcNormalMapPrevNavClk';
export const GTM_MAP_SINGLE_LISTING_PREVIEW_CLICK_B = 'XpB_MapSrcListingMapPrevNavClk';
export const GTM_MAP_SINGLE_LISTING_CLICK = 'UiSrcMapIndivPinClk';
export const GTM_MAP_SINGLE_LISTING_PREVIEW_LISTING_CLICK = 'UiSrcMapPrevListingClk';
export const GTM_MAP_SINGLE_LISTING_PREVIEW_ADDRESS_CLICK = 'UiSrcMapPrevAddressClk';

// Call CTA
export const GTM_CLICK_CALL_CTA = 'click_call';

// Sticky Header Tabs Experiment (dj-listing-sticky-tab-bar-redesign)
export const GTM_CLICK_STICKY_HEADER_TAB = 'Xp_AddressStickyTabClk';

// Zoopraisal Mortgage Calculator CTA (zoopraisal-mortgage-cta)
export const GTM_MORTGAGE_CALC_BANNER_CLICK = 'Xp_CalcBanButMortClk';

// Feedback Banner
export const GTM_FEEDBACK_BANNER_SURVEY_CLICK = 'UiAllMsgButSurveyClk';
export const GTM_FEEDBACK_BANNER_CLOSE = 'UiAllMsgButCloseClk';

// AI Search
export const GTM_SIMPLE_CHAT_VIEW = 'UiSrcSChatViewSmp';
export const GTM_SIMPLE_CHAT_SAVE_PROPERTY_TYPE = 'UiSrcSChatDrpPropertyTypeSavClk';
export const GTM_SIMPLE_CHAT_CHOOSE_BEDROOMS = 'UiSrcSChatDrpBedroomSel';
export const GTM_SIMPLE_CHAT_CHOOSE_BATHROOMS = 'UiSrcSChatDrpBathroomSel';
export const GTM_SIMPLE_CHAT_CHOOSE_BUDGET = 'UiSrcSChatDrpBudgetSel';
export const GTM_SIMPLE_CHAT_CLEAR_SEARCH = 'UiSrcSChatButClearSearchClk';
export const GTM_SIMPLE_CHAT_CLICK_ADD = 'UiSrcSChatButAddClk';
export const GTM_SIMPLE_CHAT_REMOVE_BEDROOMS = 'UiSrcSChatDrpBedroomRem';
export const GTM_SIMPLE_CHAT_REMOVE_BATHROOMS = 'UiSrcSChatDrpBathroomRem';
export const GTM_SIMPLE_CHAT_REMOVE_BUDGET = 'UiSrcSChatDrpBudgetRem';
export const GTM_SIMPLE_CHAT_SWITCH_TO_REGULAR_CHAT = 'UiSrcSChatButSwitchRegClk';
export const GTM_SIMPLE_CHAT_CLOSE_CHAT = 'UiSrcSChatWinChatCls';
export const GTM_SIMPLE_CHAT_CLOSE_LIST = 'UiSrcSChatWinListCls';
export const GTM_SIMPLE_CHAT_SAVE_SEARCH = 'UiSrcSChatButSignupClk';
export const GTM_CHATBOT_WELCOME_MODAL_NOT_NOW_CLICK = 'UiHomePMdlButNoSChatClk';
export const GTM_CHATBOT_WELCOME_MODAL_TRY_AI_HOME_SEARCH_CLICK = 'UiHomePMdlButYesSChatClk';

// SmartChat Beta Events
export const GTM_SMARTCHAT_BETA_PAGE_VIEW = 'SmChtBetaView';
export const GTM_SMARTCHAT_BETA_OPT_IN = 'SmChtBetaOptIn';
export const GTM_SMARTCHAT_BETA_OPT_OUT = 'SmChtBetaOptOut';
export const GTM_SMARTCHAT_BETA_NEW_USER_MESSAGE = 'SmChtNewUsrMsg';
export const GTM_SMARTCHAT_BETA_FILTER_APPLIED = 'SmChtFilterApplied';
export const GTM_SMARTCHAT_BETA_ERROR = 'SmChtError';
export const GTM_SMARTCHAT_BETA_SESSION_END = 'SmChtBetaSessEnd';

// Mobile Search Header Analytics
export const GTM_SEARCH_HEADER_MOBILE_AUTH_BUTTON_CLICK = 'UiSrcHeadMobButAuthClk';
export const GTM_SEARCH_HEADER_MOBILE_MENU_BUTTON_CLICK = 'UiSrcHeadMobButMenuClk';
export const GTM_SEARCH_HEADER_MOBILE_SEARCH_BAR_CLICK = 'UiSrcHeadMobSrcBarClk';

// Mobile Listing Filter Bar Analytics
export const GTM_MOBILE_FILTER_BAR_ALL_FILTERS_CLICK = 'UiSrcMobFltButClk';
export const GTM_MOBILE_FILTER_BAR_SORT_CHANGED = 'UiSrcMobFltDrpSortChg';
export const GTM_MOBILE_FILTER_BAR_SAVE_SEARCH_CLICK = 'UiSrcMobFltButSaveClk';

// Map Controls Analytics
export const GTM_MAP_SATELLITE_BUTTON_CLICK = 'UiSrcMapButSatelliteClk';
export const GTM_MAP_LIST_MAP_TOGGLE_CLICK = 'UiSrcMapButListMapToggleClk';
export const GTM_CLICK_SEARCH_MAP_ZOOM_IN = 'UiSrcMapButZoomInClk';
export const GTM_CLICK_SEARCH_MAP_ZOOM_OUT = 'UiSrcMapButZoomOutClk';
export const GTM_CLICK_SEARCH_MAP_CONTROLS_FILTER = 'UiSrcMapButFilterClk';
export const GTM_CLICK_SEARCH_MAP_MY_LOCATION = 'UiSrcMapButMyLocClk';

// Listing Card Favourite Toggle analytics
export const GTM_LISTING_CARD_FAVOURITE_TOGGLE_CLICK = 'XpA_ListingMHeartButClk';

// Home Appraisal Widget - View events (funnel)
export const GTM_WIDGET_SEARCH_VIEW = 'UiWgtSrchView';
export const GTM_WIDGET_DETAILS_VIEW = 'UiWgtDtlsView';
export const GTM_WIDGET_RESULT_VIEW = 'UiWgtRsltView';
export const GTM_WIDGET_NO_ESTIMATE_VIEW = 'UiWgtNoEstView';
// Home Appraisal Widget - Action events
export const GTM_WIDGET_SEARCH_CLICK = 'UiWgtSrchButClk';
export const GTM_WIDGET_GET_ESTIMATE_CLICK = 'UiWgtDtlsButEstClk';
export const GTM_WIDGET_BACK_CLICK = 'UiWgtButBackClk';
export const GTM_WIDGET_AGENT_CLICK = 'UiWgtButAgentClk';
// Home Appraisal Widget - Error events
export const GTM_WIDGET_ERROR = 'UiWgtErr';

// Connection Request Form (new section) - Funnel events
export const GTM_CONN_REQ_STEP1_VIEW   = 'XpConnReqStep1View';
export const GTM_CONN_REQ_STEP1_SUBMIT = 'XpConnReqStep1Submit';
export const GTM_CONN_REQ_LEGAL_VIEW   = 'XpConnReqLegalView';
export const GTM_CONN_REQ_SUCCESS_VIEW = 'XpConnReqSuccessView';
/** Generic drop-off event. `label` is the step the user was on when they closed the form. */
export const GTM_CONN_REQ_DROPOFF = 'XpConnReqDropOff';

// Connection Request Form - Legacy compatibility events (fire on submit success)
// These mirror the old form's event names and must not be renamed without a GTM update.
export const GTM_CONN_REQ_SUBMISSION = 'connection-request-submission';
export const GTM_CONN_REQ_SUBMIT_MOBILE = 'mobile-submit-pvr';
export const GTM_CONN_REQ_SUBMIT_DESKTOP = 'desktop-submit-pvr';

// Mortgage Calculator Events
// North Star Metric (Retention & Conversion) - Return within 7 days
export const GTM_CALC_RETURN_7D_VIEW = 'UiCalcRet7dView';
// Primary Metric (Engagement) - First input field interaction
export const GTM_CALC_INPUT_FIRST_EDIT = 'UiCalcInpFirstEdit';
// Secondary Metrics (Feature Usage) - Purchase price edits
export const GTM_CALC_INPUT_PRICE_EDIT = 'UiCalcInpPriceEdit';
// Secondary Metrics (Feature Usage) - Down payment % edits
export const GTM_CALC_INPUT_DOWN_PCT_EDIT = 'UiCalcInpDownPctEdit';
// Secondary Metrics (Feature Usage) - Interest rate custom entry
export const GTM_CALC_INPUT_RATE_EDIT = 'UiCalcInpRateEdit';
// Business Metrics - Lead form submission (contact/consultation)
export const GTM_CALC_LEAD_FORM_SUB = 'UiCalcLeadFormSub';
// Business Metrics - Qualified lead submission (email + sharing)
export const GTM_CALC_LEAD_QUAL_SUB = 'UiCalcLeadQualSub';
// User Experience Metrics - Form completion (results viewed after interaction)
export const GTM_CALC_FORM_COMPLETE = 'UiCalcFormCmp';
// User Experience Metrics - Trust/Feedback rating submission
export const GTM_CALC_FEEDBACK_SUB = 'UiCalcFeedbackSub';
// User Experience Metrics - Time to calculate (ms from page load to first result view)
export const GTM_CALC_RESULT_TIME = 'UiCalcResultTime';
// Engagement Deep Dive - Download PDF click
export const GTM_CALC_PDF_CLICK = 'UiCalcPdfClk';
// Engagement Deep Dive - AI Insights click
export const GTM_CALC_AI_INSIGHT_CLICK = 'UiCalcAiInsightClk';
// Engagement Deep Dive - Email Results click
export const GTM_CALC_EMAIL_CLICK = 'UiCalcEmailClk';
// Technical Metrics - Results section scroll into view
export const GTM_CALC_RESULTS_SCROLL_VIEW = 'UiCalcResScrollView';
// Technical Metrics - Recalculation time after input change (ms)
export const GTM_CALC_RECALC_TIME = 'UiCalcRecalcTime';

// My Listing My Lead
export const GTM_MLML_LISTING_EMAIL_COPY_CLICK = 'UiAddressMlMlEmailCopyClk';
export const GTM_MLML_LISTING_PHONE_COPY_CLICK = 'UiAddressMlMlPhoneCopyClk';

// Local Focus Home Page
export const GTM_LOCAL_FOCUS_HERO_SEARCH_RESULT_CLICK = 'UiHomeLFHeroSrcResultClk';
export const GTM_LOCAL_FOCUS_LISTING_CARD_CLICK = 'UiHomeLFCardListingClk';
export const GTM_LOCAL_FOCUS_LISTINGS_NAVIGATE = 'UiHomeLFListingsNavClk';
export const GTM_LOCAL_FOCUS_AREA_CARDS_VIEW = 'UiHomeLFAreaCardsView';
export const GTM_LOCAL_FOCUS_AREA_CARD_CLICK = 'UiHomeLFAreaCardClk';
export const GTM_LOCAL_FOCUS_MARKET_DYNAMICS_VIEW = 'UiHomeLFMarketDynView';
export const GTM_LOCAL_FOCUS_CITY_INSIGHTS_VIEW = 'UiHomeLFCityInsightsView';
export const GTM_LOCAL_FOCUS_CITY_INSIGHTS_NAVIGATE = 'UiHomeLFCityInsightsNavClk';
export const GTM_LOCAL_FOCUS_EXPERT_GUIDANCE_VIEW = 'UiHomeLFExpertGuidanceView';
export const GTM_LOCAL_FOCUS_FIND_AGENT_CLICK = 'UiHomeLFButFindAgentClk';